import { factory, Flex, Box, Typography, omitText } from '@kohler-dsm-library/kohler-core';
import { UserIcon, LocationIcon, FavoriteNavFilledIcon, FavoriteNavIcon } from '@kohler-dsm-library/kohler-icons';
import { clsx } from 'clsx';
import React from 'react';
import { LanguagePicker } from '../../../UtilityLinks/subcomponents/LanguagePicker/LanguagePicker.mjs';
import { getSanitizedLanguagePickerCTA } from '../../OverlayMenu.utils.mjs';
import classes from './UtilityBarMobile.module.css.mjs';

const omitFavoritesCTA = (favoritesCTA) => {
  const { isFilled = false, ...omitFavoritesCTA2 } = favoritesCTA;
  return { isFilled, omitFavoritesCTA: omitFavoritesCTA2 };
};
const UtilityBarMobile = factory((props, ref) => {
  const { utilityLinks, className, ...rest } = props;
  const { userCTA, locationPickerCTA, favoritesCTA, languagePicker, userName, isLoggedIn, utilityLinksMobile, userCTAMobile } = utilityLinks || {};
  return /* @__PURE__ */ React.createElement(Flex, { className: clsx(classes.utilityBarOverlayMobile, className), ref, ...rest }, /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: 15, paddingTop: 20, paddingBottom: 30 }, userCTA && !userCTAMobile && /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      textColor: "var(--content-primary)",
      "aria-label": isLoggedIn ? "user sign in" : "profile",
      ...userCTA,
      onClick: (e) => {
        userCTA?.onClick?.(e);
      }
    },
    /* @__PURE__ */ React.createElement(Flex, { gap: 5, align: "center", component: "span" }, /* @__PURE__ */ React.createElement(UserIcon, { withBoundingBox: true }), /* @__PURE__ */ React.createElement(Typography, { size: "navigation-s", component: "span", textColor: "var(--content-primary)" }, userCTA.text ? userCTA.text : isLoggedIn && userName ? `Hi, ${userName}` : "Sign in / Create Account"))
  ), userCTAMobile && /* @__PURE__ */ React.createElement(React.Fragment, null, !isLoggedIn && /* @__PURE__ */ React.createElement(Box, { textColor: "var(--content-primary)", className: classes.userCTAMobileWrapper }, /* @__PURE__ */ React.createElement(
    Flex,
    {
      gap: 5,
      align: "center",
      component: "button",
      type: "button",
      onClick: (e) => {
        const userCTAOnClick = userCTAMobile?.signInCTA?.onClick;
        if (!userCTAOnClick) {
          userCTA?.onClick?.(e);
        } else {
          userCTAOnClick(e);
        }
      },
      ...omitText(userCTAMobile.signInCTA)
    },
    /* @__PURE__ */ React.createElement(UserIcon, { withBoundingBox: true }),
    /* @__PURE__ */ React.createElement(Typography, { size: "navigation-s", component: "div", textColor: "var(--content-primary)" }, userCTAMobile.signInCTA.text ? userCTAMobile.signInCTA.text : "Sign in ")
  ), /* @__PURE__ */ React.createElement(Typography, { size: "navigation-s", component: "span", textColor: "var(--content-primary)" }, "/"), /* @__PURE__ */ React.createElement(
    Typography,
    {
      size: "navigation-s",
      component: "button",
      type: "button",
      textColor: "var(--content-primary)",
      onClick: (e) => {
        const userCTAOnClick = userCTAMobile?.signUpCTA?.onClick;
        if (!userCTAOnClick) {
          userCTA?.onClick?.(e);
        } else {
          userCTAOnClick(e);
        }
      },
      ...omitText(userCTAMobile.signUpCTA)
    },
    userCTAMobile.signUpCTA.text ? userCTAMobile.signUpCTA.text : "Create Account"
  )), isLoggedIn && /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      textColor: "var(--content-primary)",
      ...userCTAMobile.accountCTA,
      onClick: (e) => {
        const userCTAOnClick = userCTAMobile?.accountCTA?.onClick;
        if (!userCTAOnClick) {
          userCTA?.onClick?.(e);
        } else {
          userCTAOnClick(e);
        }
      }
    },
    /* @__PURE__ */ React.createElement(Flex, { gap: 5, align: "center", component: "span" }, /* @__PURE__ */ React.createElement(UserIcon, { withBoundingBox: true }), /* @__PURE__ */ React.createElement(Typography, { size: "navigation-s", component: "span", textColor: "var(--content-primary)" }, userCTAMobile.accountCTA.text ? userCTAMobile.accountCTA.text : `Hi, ${userName}`))
  )), utilityLinksMobile && utilityLinksMobile.length > 0 && utilityLinksMobile.map((utilityLink) => {
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        key: utilityLink.text,
        component: "a",
        textColor: "var(--content-primary)",
        ...omitText(utilityLink),
        className: classes.utilityLink
      },
      /* @__PURE__ */ React.createElement(Typography, { size: "navigation-s", component: "span", textColor: "var(--content-primary)" }, utilityLink.text)
    );
  }), locationPickerCTA && /* @__PURE__ */ React.createElement(
    Flex,
    {
      gap: 5,
      align: "center",
      component: "button",
      ...locationPickerCTA,
      onClick: (e) => {
        locationPickerCTA?.onClick?.(e);
      }
    },
    /* @__PURE__ */ React.createElement(LocationIcon, { withBoundingBox: true }),
    /* @__PURE__ */ React.createElement(Typography, { size: "navigation-s", component: "span", textColor: "var(--content-primary)" }, locationPickerCTA.text || "Find a Store")
  ), favoritesCTA && /* @__PURE__ */ React.createElement(
    Flex,
    {
      component: "a",
      align: "center",
      gap: 5,
      "aria-label": "see favorites",
      textColor: "var(--content-primary)",
      ...omitFavoritesCTA(favoritesCTA).omitFavoritesCTA
    },
    omitFavoritesCTA(favoritesCTA).isFilled ? /* @__PURE__ */ React.createElement(FavoriteNavFilledIcon, { withBoundingBox: true }) : /* @__PURE__ */ React.createElement(FavoriteNavIcon, { withBoundingBox: true }),
    /* @__PURE__ */ React.createElement(Typography, { size: "navigation-s", component: "span", textColor: "var(--content-primary)" }, favoritesCTA.text || "Favorites")
  )), languagePicker && /* @__PURE__ */ React.createElement(Flex, { paddingBlock: 20, borderTop: "1px solid var(--border-tertiary)" }, /* @__PURE__ */ React.createElement(
    LanguagePicker,
    {
      ...languagePicker,
      languagePickerCTA: {
        ...getSanitizedLanguagePickerCTA(languagePicker),
        className: languagePicker.languagePickerCTA.className,
        onClick: (e) => {
          if (languagePicker?.languagePickerCTA && languagePicker?.languagePickerCTA?.onClick) {
            languagePicker?.languagePickerCTA?.onClick(e);
          }
        }
      },
      textColor: "var(--content-primary)"
    }
  )));
});

export { UtilityBarMobile };
